import { render } from "./Wrapper.vue?vue&type=template&id=6edca0f9"
const script = {}

import exportComponent from "/Volumes/INNCOM/MUSOON Project/2103.musoon.mobile.vue/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.43_vue@3.5.43_webpack@4.47.0_supports-color@6.1.0_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__